module.exports = __webpack_public_path__ + "static/media/Emoji.ce55f5e8.png";